// This file is auto-generated by @hey-api/openapi-ts

import { client } from './Client.gen';
import type { EshopCustomerControllerAddCustomerCardData } from './EshopCustomerControllerAddCustomerCardData.gen';
import type { EshopCustomerControllerAddCustomerCardErrors } from './EshopCustomerControllerAddCustomerCardErrors.gen';
import type { EshopCustomerControllerAddCustomerCardFinishTokenizationData } from './EshopCustomerControllerAddCustomerCardFinishTokenizationData.gen';
import type { EshopCustomerControllerAddCustomerCardFinishTokenizationErrors } from './EshopCustomerControllerAddCustomerCardFinishTokenizationErrors.gen';
import type { EshopCustomerControllerAddCustomerCardFinishTokenizationResponses } from './EshopCustomerControllerAddCustomerCardFinishTokenizationResponses.gen';
import type { EshopCustomerControllerAddCustomerCardInitTokenizationData } from './EshopCustomerControllerAddCustomerCardInitTokenizationData.gen';
import type { EshopCustomerControllerAddCustomerCardInitTokenizationErrors } from './EshopCustomerControllerAddCustomerCardInitTokenizationErrors.gen';
import type { EshopCustomerControllerAddCustomerCardInitTokenizationResponses } from './EshopCustomerControllerAddCustomerCardInitTokenizationResponses.gen';
import type { EshopCustomerControllerAddCustomerCardResponses } from './EshopCustomerControllerAddCustomerCardResponses.gen';
import type { EshopCustomerControllerCancelEshopTicketFareData } from './EshopCustomerControllerCancelEshopTicketFareData.gen';
import type { EshopCustomerControllerCancelEshopTicketFareErrors } from './EshopCustomerControllerCancelEshopTicketFareErrors.gen';
import type { EshopCustomerControllerCancelEshopTicketFareResponses } from './EshopCustomerControllerCancelEshopTicketFareResponses.gen';
import type { EshopCustomerControllerCheckCreationOfVirtualCardApplicationData } from './EshopCustomerControllerCheckCreationOfVirtualCardApplicationData.gen';
import type { EshopCustomerControllerCheckCreationOfVirtualCardApplicationErrors } from './EshopCustomerControllerCheckCreationOfVirtualCardApplicationErrors.gen';
import type { EshopCustomerControllerCheckCreationOfVirtualCardApplicationResponses } from './EshopCustomerControllerCheckCreationOfVirtualCardApplicationResponses.gen';
import type { EshopCustomerControllerCheckRegisteredCustomerData } from './EshopCustomerControllerCheckRegisteredCustomerData.gen';
import type { EshopCustomerControllerCheckRegisteredCustomerErrors } from './EshopCustomerControllerCheckRegisteredCustomerErrors.gen';
import type { EshopCustomerControllerCheckRegisteredCustomerResponses } from './EshopCustomerControllerCheckRegisteredCustomerResponses.gen';
import type { EshopCustomerControllerConnectAssignedAccountData } from './EshopCustomerControllerConnectAssignedAccountData.gen';
import type { EshopCustomerControllerConnectAssignedAccountErrors } from './EshopCustomerControllerConnectAssignedAccountErrors.gen';
import type { EshopCustomerControllerConnectAssignedAccountResponses } from './EshopCustomerControllerConnectAssignedAccountResponses.gen';
import type { EshopCustomerControllerConnectRegisteredAccountData } from './EshopCustomerControllerConnectRegisteredAccountData.gen';
import type { EshopCustomerControllerConnectRegisteredAccountErrors } from './EshopCustomerControllerConnectRegisteredAccountErrors.gen';
import type { EshopCustomerControllerConnectRegisteredAccountResponses } from './EshopCustomerControllerConnectRegisteredAccountResponses.gen';
import type { EshopCustomerControllerCreateData } from './EshopCustomerControllerCreateData.gen';
import type { EshopCustomerControllerCreateErrors } from './EshopCustomerControllerCreateErrors.gen';
import type { EshopCustomerControllerCreateResponses } from './EshopCustomerControllerCreateResponses.gen';
import type { EshopCustomerControllerEWalletPakTransferData } from './EshopCustomerControllerEWalletPakTransferData.gen';
import type { EshopCustomerControllerEWalletPakTransferErrors } from './EshopCustomerControllerEWalletPakTransferErrors.gen';
import type { EshopCustomerControllerEWalletPakTransferResponses } from './EshopCustomerControllerEWalletPakTransferResponses.gen';
import type { EshopCustomerControllerGetAccountsManagingCardData } from './EshopCustomerControllerGetAccountsManagingCardData.gen';
import type { EshopCustomerControllerGetAccountsManagingCardErrors } from './EshopCustomerControllerGetAccountsManagingCardErrors.gen';
import type { EshopCustomerControllerGetAccountsManagingCardResponses } from './EshopCustomerControllerGetAccountsManagingCardResponses.gen';
import type { EshopCustomerControllerGetActiveOrProcessedCardApplicationData } from './EshopCustomerControllerGetActiveOrProcessedCardApplicationData.gen';
import type { EshopCustomerControllerGetActiveOrProcessedCardApplicationErrors } from './EshopCustomerControllerGetActiveOrProcessedCardApplicationErrors.gen';
import type { EshopCustomerControllerGetActiveOrProcessedCardApplicationResponses } from './EshopCustomerControllerGetActiveOrProcessedCardApplicationResponses.gen';
import type { EshopCustomerControllerGetCustomerActiveCardData } from './EshopCustomerControllerGetCustomerActiveCardData.gen';
import type { EshopCustomerControllerGetCustomerActiveCardErrors } from './EshopCustomerControllerGetCustomerActiveCardErrors.gen';
import type { EshopCustomerControllerGetCustomerActiveCardResponses } from './EshopCustomerControllerGetCustomerActiveCardResponses.gen';
import type { EshopCustomerControllerGetCustomerLastActiveCardData } from './EshopCustomerControllerGetCustomerLastActiveCardData.gen';
import type { EshopCustomerControllerGetCustomerLastActiveCardErrors } from './EshopCustomerControllerGetCustomerLastActiveCardErrors.gen';
import type { EshopCustomerControllerGetCustomerLastActiveCardResponses } from './EshopCustomerControllerGetCustomerLastActiveCardResponses.gen';
import type { EshopCustomerControllerGetCustomerProfileApplicationsData } from './EshopCustomerControllerGetCustomerProfileApplicationsData.gen';
import type { EshopCustomerControllerGetCustomerProfileApplicationsErrors } from './EshopCustomerControllerGetCustomerProfileApplicationsErrors.gen';
import type { EshopCustomerControllerGetCustomerProfileApplicationsResponses } from './EshopCustomerControllerGetCustomerProfileApplicationsResponses.gen';
import type { EshopCustomerControllerGetIsicTicketFarePriceData } from './EshopCustomerControllerGetIsicTicketFarePriceData.gen';
import type { EshopCustomerControllerGetIsicTicketFarePriceErrors } from './EshopCustomerControllerGetIsicTicketFarePriceErrors.gen';
import type { EshopCustomerControllerGetIsicTicketFarePriceResponses } from './EshopCustomerControllerGetIsicTicketFarePriceResponses.gen';
import type { EshopCustomerControllerGetLoggedCustomerData } from './EshopCustomerControllerGetLoggedCustomerData.gen';
import type { EshopCustomerControllerGetLoggedCustomerErrors } from './EshopCustomerControllerGetLoggedCustomerErrors.gen';
import type { EshopCustomerControllerGetLoggedCustomerResponses } from './EshopCustomerControllerGetLoggedCustomerResponses.gen';
import type { EshopCustomerControllerGetOneByNameAndBirthDayData } from './EshopCustomerControllerGetOneByNameAndBirthDayData.gen';
import type { EshopCustomerControllerGetOneByNameAndBirthDayErrors } from './EshopCustomerControllerGetOneByNameAndBirthDayErrors.gen';
import type { EshopCustomerControllerGetOneByNameAndBirthDayResponses } from './EshopCustomerControllerGetOneByNameAndBirthDayResponses.gen';
import type { EshopCustomerControllerGetOneData } from './EshopCustomerControllerGetOneData.gen';
import type { EshopCustomerControllerGetOneErrors } from './EshopCustomerControllerGetOneErrors.gen';
import type { EshopCustomerControllerGetOneResponses } from './EshopCustomerControllerGetOneResponses.gen';
import type { EshopCustomerControllerIsCustomerManageableData } from './EshopCustomerControllerIsCustomerManageableData.gen';
import type { EshopCustomerControllerIsCustomerManageableErrors } from './EshopCustomerControllerIsCustomerManageableErrors.gen';
import type { EshopCustomerControllerIsCustomerManageableResponses } from './EshopCustomerControllerIsCustomerManageableResponses.gen';
import type { EshopCustomerControllerSetCustomerCustodianData } from './EshopCustomerControllerSetCustomerCustodianData.gen';
import type { EshopCustomerControllerSetCustomerCustodianErrors } from './EshopCustomerControllerSetCustomerCustodianErrors.gen';
import type { EshopCustomerControllerSetCustomerCustodianResponses } from './EshopCustomerControllerSetCustomerCustodianResponses.gen';
import type { EshopCustomerControllerSetCustomerOriginData } from './EshopCustomerControllerSetCustomerOriginData.gen';
import type { EshopCustomerControllerSetCustomerOriginErrors } from './EshopCustomerControllerSetCustomerOriginErrors.gen';
import type { EshopCustomerControllerSetCustomerOriginResponses } from './EshopCustomerControllerSetCustomerOriginResponses.gen';
import type { EshopCustomerControllerUpdateData } from './EshopCustomerControllerUpdateData.gen';
import type { EshopCustomerControllerUpdateErrors } from './EshopCustomerControllerUpdateErrors.gen';
import type { EshopCustomerControllerUpdateResponses } from './EshopCustomerControllerUpdateResponses.gen';
import type { EshopCustomerControllerVerifyIfCustomerIsUniqueData } from './EshopCustomerControllerVerifyIfCustomerIsUniqueData.gen';
import type { EshopCustomerControllerVerifyIfCustomerIsUniqueErrors } from './EshopCustomerControllerVerifyIfCustomerIsUniqueErrors.gen';
import type { EshopCustomerControllerVerifyIfCustomerIsUniqueResponses } from './EshopCustomerControllerVerifyIfCustomerIsUniqueResponses.gen';
import type { EshopCustomerControllerVerifyIsicCardNumberData } from './EshopCustomerControllerVerifyIsicCardNumberData.gen';
import type { EshopCustomerControllerVerifyIsicCardNumberErrors } from './EshopCustomerControllerVerifyIsicCardNumberErrors.gen';
import type { EshopCustomerControllerVerifyIsicCardNumberResponses } from './EshopCustomerControllerVerifyIsicCardNumberResponses.gen';
import type { Options } from './Options.gen';

export class EshopCustomerController {
    /**
     * Get customer by name and birthday.
     */
    public static getOneByNameAndBirthDay<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetOneByNameAndBirthDayData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetOneByNameAndBirthDayResponses, EshopCustomerControllerGetOneByNameAndBirthDayErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/one-by-name-and-birthday',
            ...options
        });
    }
    
    /**
     * Get customer.
     */
    public static getOne<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetOneData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetOneResponses, EshopCustomerControllerGetOneErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}',
            ...options
        });
    }
    
    /**
     * Update a customer.
     *
     * If a request body payload exceeds 5MB, Bad Request error `INVALID_PHOTO_SIZE` is returned.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CUSTOMER_NOT_UNIQUE** - Customer name and birthday combination is not unique.<br>
     * + **INVALID_PHOTO_SIZE** - The customer's photo is too big, 400kB is maximum.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.<br>
     * + **INVALID_GDPR_OR_TERMS_APPROVAL** - GDPR, terms and conditions must be approved.<br>
     * + **CUSTODIAN_IS_REQUIRED** - Custodian is required for customer under the age of 15.<br>
     * + **CANNOT_CHANGE_BIRTHDAY** - Customer can´t change birthday.
     */
    public static update<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerUpdateData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerControllerUpdateResponses, EshopCustomerControllerUpdateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Create a customer.
     *
     * If a request body payload exceeds 5MB, Bad Request error `INVALID_PHOTO_SIZE` is returned.<br>
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CUSTOMER_NOT_UNIQUE** - Customer name and birthday combination is not unique.<br>
     * + **INVALID_PHOTO_SIZE** - The customer's photo is too big, 400kB is maximum.<br>
     * + **INVALID_CUSTOMER** - Customer does not exist, belongs to another account, is a draft or origin.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.<br>
     * + **INVALID_GDPR_OR_TERMS_APPROVAL** - GDPR, terms and conditions must be approved.<br>
     * + **CUSTODIAN_IS_REQUIRED** - Custodian is required for customer under the age of 15.<br>
     * + **CANNOT_CHANGE_BIRTHDAY** - Customer can´t change birthday.<br>
     * + **INVALID_CHILD_AGE** - Child age is outside the allowed range.
     */
    public static create<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerCreateData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerControllerCreateResponses, EshopCustomerControllerCreateErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get active card for the given customer.
     *
     * If customer has no active card, `NOT FOUND` response is returned.
     */
    public static getCustomerActiveCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetCustomerActiveCardData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetCustomerActiveCardResponses, EshopCustomerControllerGetCustomerActiveCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/active-card',
            ...options
        });
    }
    
    /**
     * Cancel eshop ticket fare.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **TICKET_EXPIRED** - Cannot perform the action on the expired ticket.<br>
     * + **TICKET_NOT_CANCELLABLE** - Cannot cancel parent of cancelled ticket or cancelled ticket or ticket is a draft.
     */
    public static cancelEshopTicketFare<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerCancelEshopTicketFareData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerControllerCancelEshopTicketFareResponses, EshopCustomerControllerCancelEshopTicketFareErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/eshop-ticket-fare-cancel',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get active or processed card application. State: UNCHECKED or WAITING TO PRINT
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.
     */
    public static getActiveOrProcessedCardApplication<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetActiveOrProcessedCardApplicationData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetActiveOrProcessedCardApplicationResponses, EshopCustomerControllerGetActiveOrProcessedCardApplicationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/active-or-processed-card-application',
            ...options
        });
    }
    
    /**
     * Returns an error if there is an ongoing card-application or ongoing virtual-card-application. Also returns an error if the customer has a card in_progress or not_issued.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CUSTOMER_ALREADY_HAS_ACTIVE_CARD_APPLICATION** - Customer already has active card application.<br>
     * + **CUSTOMER_HAS_CARD_TO_BE_ISSUED** - The customer has a card in state "IN_PROGRESS" or "NOT_ISSUED".
     */
    public static checkCreationOfVirtualCardApplication<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerCheckCreationOfVirtualCardApplicationData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerCheckCreationOfVirtualCardApplicationResponses, EshopCustomerControllerCheckCreationOfVirtualCardApplicationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/virtual-card-application-creation-check',
            ...options
        });
    }
    
    /**
     * Check if combination of first name, last name and birthday is unique.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **CUSTOMER_NOT_UNIQUE** - Customer name and birthday combination is not unique.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.
     */
    public static verifyIfCustomerIsUnique<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerVerifyIfCustomerIsUniqueData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerVerifyIfCustomerIsUniqueResponses, EshopCustomerControllerVerifyIfCustomerIsUniqueErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-check',
            ...options
        });
    }
    
    /**
     * Check if combination of first name, last name and isic card number is valid with with the discount on the customer profile.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **ISIC_CARD_NUMBER_ALREADY_USED** - Isic card number is already used in the system.<br>
     * + **INVALID_ACCOUNT** - Account does not exist or another customer is assigned to this account.<br>
     * + **ISIC_CARD_NUMBER_NOT_VALID** - Isic card number is not valid for customer and discount.
     */
    public static verifyIsicCardNumber<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerVerifyIsicCardNumberData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerVerifyIsicCardNumberResponses, EshopCustomerControllerVerifyIsicCardNumberErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-check-isic-card-validation',
            ...options
        });
    }
    
    /**
     * Get last card for the given customer.
     *
     * If customer has no last card, `NOT FOUND` response is returned.
     */
    public static getCustomerLastActiveCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetCustomerLastActiveCardData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetCustomerLastActiveCardResponses, EshopCustomerControllerGetCustomerLastActiveCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/last-active-card',
            ...options
        });
    }
    
    /**
     * List of accounts managing customer card.
     */
    public static getAccountsManagingCard<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerControllerGetAccountsManagingCardData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerControllerGetAccountsManagingCardResponses, EshopCustomerControllerGetAccountsManagingCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-managing-accounts-card',
            ...options
        });
    }
    
    /**
     * Connect customer with account as REGISTERED based on card number and application number.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_CUSTOMER_CARD_AND_CARD_APPLICATION** - Invalid customer card and card application combination.<br>
     * + **ACCOUNT_ALREADY_HAS_REGISTERED_CUSTOMER** - Account already has registered customer.<br>
     * + **CUSTOMER_ALREADY_HAS_REGISTERED_ACCOUNT** - Customer already has a registered account.<br>
     * + **CUSTOMER_TOO_YOUNG_TO_CREATE_REGISTERED_ACCOUNT** - Customer is not able register to eshop account (too young).<br>
     * + **INVALID_CARD_APPLICATION_USERNAME** - Invalid card application username.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.<br>
     * + **INVALID_CUSTOMER_AGE_FOR_REGISTRATION** - Invalid account age for registration with this customer card.<br>
     * + **INVALID_CARD_PROVIDER** - Card provider is invalid for this operation.
     */
    public static connectRegisteredAccount<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerConnectRegisteredAccountData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerControllerConnectRegisteredAccountResponses, EshopCustomerControllerConnectRegisteredAccountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-connect-registered-account',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Connect customer with account as ASSIGNED based on card number and application number.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_CUSTOMER_CARD_AND_CARD_APPLICATION** - Invalid customer card and card application combination.<br>
     * + **CANNOT_ASSIGN_CUSTOMER_WITHOUT_PARENT_TO_ACCOUNT** - Can not assign customer without parent to account.<br>
     * + **CUSTOMER_ALREADY_HAS_ASSIGNED_ACCOUNT** - Customer already has a assigned account.<br>
     * + **CUSTOMER_TOO_OLD_TO_CREATE_ASSIGNED_ACCOUNT** - Customer is not able assign to eshop account (too old).<br>
     * + **CUSTOMER_PARENT_AND_ACCOUNT_OWNER_ARE_DIFFERENT** - Customer parent and account owner are different.
     */
    public static connectAssignedAccount<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerConnectAssignedAccountData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerControllerConnectAssignedAccountResponses, EshopCustomerControllerConnectAssignedAccountErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-connect-assigned-account',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Transfer electronic wallet from PaK to MAP card for the eshop customer.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **INVALID_CARD_STATE** - Card state does not exist or is invalid.<br>
     * + **PAK_WALLET_NEGATIVE_AMOUNT** - PaK electronic wallet has negative current amount.<br>
     * + **PAK_WALLET_ALREADY_TRANSFERRED** - PaK electronic wallet has already been transferred.<br>
     * + **PAK_WALLET_INCORRECT_NAME_OR_BIRTHDAY** - PaK electronic wallet and MAP card do not have the same customer's name or birthday.<br>
     * + **INVALID_CUSTOMER_CARD** - Customer card does not exist or has invalid card state.
     */
    public static eWalletPakTransfer<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerEWalletPakTransferData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerControllerEWalletPakTransferResponses, EshopCustomerControllerEWalletPakTransferErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-pak-transfer/wallet',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get a customer info for the logged in account.
     *
     * Returns null in "data" if there is no registered customer for that account.
     */
    public static getLoggedCustomer<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerControllerGetLoggedCustomerData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerControllerGetLoggedCustomerResponses, EshopCustomerControllerGetLoggedCustomerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-logged-customer',
            ...options
        });
    }
    
    /**
     * Check if account has only managed relations with customer.
     */
    public static checkRegisteredCustomer<ThrowOnError extends boolean = false>(options?: Options<EshopCustomerControllerCheckRegisteredCustomerData, ThrowOnError>) {
        return (options?.client ?? client).get<EshopCustomerControllerCheckRegisteredCustomerResponses, EshopCustomerControllerCheckRegisteredCustomerErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers-check-only-managed-relations',
            ...options
        });
    }
    
    /**
     * Check customer can be managed.
     *
     * Customer must be registered or child and has only one active card.
     */
    public static isCustomerManageable<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerIsCustomerManageableData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerIsCustomerManageableResponses, EshopCustomerControllerIsCustomerManageableErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/check-manageable',
            ...options
        });
    }
    
    /**
     * Assign customer custodian.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static setCustomerCustodian<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerSetCustomerCustodianData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerControllerSetCustomerCustodianResponses, EshopCustomerControllerSetCustomerCustodianErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/assign-custodian',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Assign customer origin.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static setCustomerOrigin<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerSetCustomerOriginData, ThrowOnError>) {
        return (options.client ?? client).put<EshopCustomerControllerSetCustomerOriginResponses, EshopCustomerControllerSetCustomerOriginErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/assign-origin',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Get ticket fare price buy by isic.
     */
    public static getIsicTicketFarePrice<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetIsicTicketFarePriceData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetIsicTicketFarePriceResponses, EshopCustomerControllerGetIsicTicketFarePriceErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/isic-ticket-fare-price',
            ...options
        });
    }
    
    /**
     * Get customer profile application list for the given customer.
     *
     * Field `stateIds` must be send as stateIds[]=value.
     */
    public static getCustomerProfileApplications<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerGetCustomerProfileApplicationsData, ThrowOnError>) {
        return (options.client ?? client).get<EshopCustomerControllerGetCustomerProfileApplicationsResponses, EshopCustomerControllerGetCustomerProfileApplicationsErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/customer-profile-applications',
            ...options
        });
    }
    
    /**
     * Add customer card.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.
     */
    public static addCustomerCard<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerAddCustomerCardData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerControllerAddCustomerCardResponses, EshopCustomerControllerAddCustomerCardErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/add-card',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Init a tokenization.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **CANNOT_INIT_TOKENIZATION** - Tokenization cannot be initialized.
     */
    public static addCustomerCardInitTokenization<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerAddCustomerCardInitTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerControllerAddCustomerCardInitTokenizationResponses, EshopCustomerControllerAddCustomerCardInitTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/add-card/init-tokenization',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
    
    /**
     * Finish a tokenization.
     *
     * ### Error names for HTTP Status 400 BadRequest:<br>
     * + **VALIDATION_ERROR** - Invalid body, check 'errors' property for more info.<br>
     * + **INVALID_CARD_APPLICATION** - Card application is invalid or does not exist.<br>
     * + **CHIP_NUMBER_NOT_UNIQUE** - Chip number already exists.<br>
     * + **CARD_HAS_UNPROCESSED_TRANSACTIONS** - Card has unprocessed transactions. Upload all transactions to card first.<br>
     * + **CANNOT_FINISH_TOKENIZATION** - Tokenization cannot be finished.<br>
     * + **CANNOT_MAKE_VIRTUAL_CARDPHOTO_THUMBNAIL** - Can not make virtual card photo thumbnail.
     */
    public static addCustomerCardFinishTokenization<ThrowOnError extends boolean = false>(options: Options<EshopCustomerControllerAddCustomerCardFinishTokenizationData, ThrowOnError>) {
        return (options.client ?? client).post<EshopCustomerControllerAddCustomerCardFinishTokenizationResponses, EshopCustomerControllerAddCustomerCardFinishTokenizationErrors, ThrowOnError>({
            security: [{ scheme: 'bearer', type: 'http' }],
            url: '/api/eshop/customers/{id}/add-card/finish-tokenization',
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options.headers
            }
        });
    }
}
